import {IContactEmailApi} from '../../api/contact-email-api.service';
import {StateService} from 'angular-ui-router';

export interface IContactFormData {
    name: string;
    email: string;
    content: string;
}


export default class HelpController {
  static $inject = ['contactEmailApi', '$mdDialog', '$state', '$timeout', '$translate'];

  contactForm: IContactFormData;
  sending: boolean = false;

  constructor(private contactEmailApi: IContactEmailApi,
              private $mdDialog: ng.material.IDialogService,
              private $state: StateService,
              private $timeout: ng.ITimeoutService,
              private $translate:ng.translate.ITranslateService) {

  }

  sendEmail = () => {

      let self = this;
      self.sending = true;

      this.contactEmailApi.sendContactEmail(this.contactForm)
          .then(function(){

              self.sending = false;

              self.$mdDialog
                  .show(
                      self.$mdDialog.alert()
                          .title(self.$translate.instant('THANK_YOU'))
                          .textContent(self.$translate.instant('WE_WILL_CONTACT_YOU_ASAP'))
                          .ok('OK')
                    )
                  .then(function () {
                      self.$state.go('home');
                  });

          }, function () {

              self.sending = false;

              self.$mdDialog
                  .show(
                      self.$mdDialog.alert()
                          .title(self.$translate.instant('WE_ARE_SORRY'))
                          .textContent(self.$translate.instant('HELP_MESSAGE_ERROR'))
                          .ok('OK')
                  );

          });


  };

}



/** WEBPACK FOOTER **
 ** ./app/hydromet/help/help.controller.ts
 **/